import { Link } from "react-router-dom";
import styled, { FlattenSimpleInterpolation, createGlobalStyle, css } from "styled-components";
import { FomrmLoginInput, FomrmLoginInputPhoneNumberWrap } from "../../LoginUser/styled/LoginStyles";
import { PartnerInnerTopName } from "../../Map/styled/HomeStyles";
import User from "../../../../models/User";
import { Tooltip } from "@material-ui/core";

export const OrderInner = styled.div`
    width: 1200px;
    position: relative;
    margin: auto;
    max-width: 1440px;
    display: flex;
    font-size:16px;
    justify-content: space-between;
	
	@media screen and (max-width: 768px) {
		margin: 0;
		width: 100%;
		padding: 16px;
		height: inherit;
		align-items: center;
		}
	}
`;
export const OrderInnerOrderPageInfomation = styled(OrderInner)`
	padding: 24px 0 80px 0;
	@media screen and (max-width: 768px) {
		display: flex;
		flex-direction: column-reverse;
		padding: 0px 0 80px 0;
	}
`;
export const OrderPageNavigationWrap = styled.div`
	display: flex;
	padding: 16px 0;

	align-items: center;
	@media screen and (max-width: 768px) {
		padding: 0;
	}
`;

export const OrderPageNavigationInner = styled(Link) <{ status?: number }>`
	// color: #080D08;
	font-size: 14px;
	font-weight: 500;
	line-height: 22px;
	pointer-events: ${({ status }) => (status === 1 ? "none" : "")};
	color: ${({ status }) => (status === 1 ? "#6B7280" : "#080D08")};
	text-decoration: none;
`;
export const OrderPageNavigationImg = styled.img`
	width: 12px;
	height: 12px;
	margin: 0 8px;
`;
export const OrderPageInfomationLeftWrap = styled.div`
	width: 650px;
	@media screen and (max-width: 768px) {
		width: 100%;
	}
`;

export const OrderPageInfomationRightWrap = styled.div`
	width: 490px;
	display: flex;
	padding: 24px;
	flex-direction: column;
	align-items: flex-start;
	border-radius: var(--16, 16px);
	border: 1px solid #ddd;
	background: var(--Background-White, #fff);
	box-shadow: 0px 4px 15.3px 0px rgba(17, 24, 39, 0.08);
	float: right;

	@media screen and (max-width: 768px) {
		width: 100%;
		border: none;
		padding: 16px;
		box-shadow: none;
	}
`;

export const ContactInfoWrap = styled.div`
	width: 650px;
	@media screen and (max-width: 768px) {
		width: 100%;
		padding: 0 16px;
	}
`;

export const ContactInfoTitle = styled.div`
	color: #111827;
	font-size: 18px;
	font-weight: 600;
	line-height: 24px;
	margin-top: 32px;
	@media screen and (max-width: 768px) {
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
	}
`;
export const OrderInnerTop = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	@media screen and (max-width: 768px) {
		// display:none;
	}
`;
export const OrderInnerTopWeb = styled.div`
	display: block;
	width: 100%;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const OrderInnerTopMobile = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		display: block;
		width: 100%;
		padding: 0 16px;
	}
`;
export const CountryTopWeb = styled.div`
	display: block;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const CountryTopMobile = styled.div<{ signup?: boolean }>`
	display: none;
	@media screen and (max-width: 768px) {
		display: block;
		width: 100%;
		padding: 8px 12px;
		border-bottom: ${({ signup }) => (signup ? "none" : "1px solid rgb(209, 213, 219)")};
		border: ${({ signup }) => (signup ? "1px solid rgb(209, 213, 219)" : "")};
		border-radius: ${({ signup }) => (signup ? "8px" : "0")};
		margin-bottom: ${({ signup }) => (signup ? "16px" : "0")};
	}
`;
export const CountryTopMobilev2 = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		display: block;
		width: 100%;
		padding: 8px 12px;
		border: 1px solid #e5e7eb;
		border-radius: 8px 8px 0 0;
	}
`;
export const CountryTopMobileLabel = styled.label`
	display: none;
	@media screen and (max-width: 768px) {
		display: block;
		width: 100%;
		color: #6b7280;
		font-size: 12px;
		font-weight: 500;
		line-height: 16px;
	}
`;
export const InnerTopMobileLabel = styled.label`
	display: block;
	width: 100%;
	color: #6b7280;
	font-size: 12px;
	font-weight: 500;
	line-height: 16px;
`;
export const OrderInput = styled(FomrmLoginInput)`
	border: none;
	border-bottom-left-radius: 0;
	border-bottom-right-radius: 0;
	border-bottom: 1px solid rgb(209, 213, 219);
	margin-bottom: 0;
	outline: none;
`;
export const OrderInputPhoneNumberWrap = styled(FomrmLoginInputPhoneNumberWrap)`
	border: none;
	border-radius: 0;
	// padding: 0 16px;
	margin-bottom: 0;
`;
export const OrderInputWrap = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	width: 100%;
	border-radius: 8px;
	border: 1px solid #d1d5db;
	margin: 16px 0;
	@media screen and (max-width: 768px) {
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
	}
`;

export const OrderCheckoutButton = styled.button<{ disabled: boolean }>`
	border-radius: 8px;
	// background: #035D9D;
	display: flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	color: #fff;
	width: 100%;
	border: none;
	margin-bottom: 16px;
	pointer-events: ${({ disabled }) => (disabled ? "none" : "")};
	background: ${({ disabled }) => (disabled ? "#ccc" : "#035D9D")};
	cursor: pointer;
	font-family: inherit;
`;

export const OrderPageCheckoutReturn = styled.div`
	color: #111827;
	font-size: 20px;
	font-weight: 600;
	line-height: 24px;
	margin-bottom: 16px;
	cursor: pointer;
	display: flex;
	align-items: center;
`;

export const OrderPageCheckoutReturnImg = styled.img`
	height: 24px;
	width: 24px;
	margin-right: 8px;
`;

export const OrderPageCheckoutPayWrap = styled.div`
	width: 649px;
	@media screen and (max-width: 768px) {
		width: 100%;
	}
`;
export const OrderPageCheckoutPay = styled.div`
	display: flex;
	height: 72px;
	padding: 16px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	
	border-radius: 4px;
	border: 1px solid #000;
	cursor: pointer;

	&:hover {
		background-color: #f2f2f2;
	}
	margin-bottom: 8px;
	@media screen and (max-width: 768px) {
		border: 1px solid #555;
	}
`;

export const OrderPageCheckoutPayOnePay1 = styled.div`
	color: #111827;
	text-align: center;
	font-size: 18px;
	font-weight: 500;
	line-height: 24px;
	@media screen and (max-width: 768px) {
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
	}
`;
export const OrderPageCheckoutPayOnePay2 = styled.div`
	color: #111827;
	text-align: center;
	font-size: 14px;
	font-weight: 400;
	line-height: 24px;
	@media screen and (max-width: 768px) {
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 20px;
	}
`;
export const OrderPageCheckoutPayImg = styled.img`
	width: 88px;
	height: 28px;
`;

export const OrderCheckoutNote = styled.div`
	color: #111827;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 20px;
	margin-top: 16px;
	@media screen and (max-width: 768px) {
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
	}
`;
export const OrderCheckoutNoteLink = styled(Link)`
	color: #111827;
	font-size: 14px;
	font-style: normal;
	font-weight: 700;
	line-height: 20px;
	margin-top: 16px;
	@media screen and (max-width: 768px) {
		font-size: 14px;
		font-weight: 700;
		line-height: 20px;
	}
`;

export const OrderPageInfomationTimeWrap = styled.div`
	display: flex;
	padding: 16px;
	align-items: center;
	gap: v16px;
	border-radius: 8px;
	border: 1px solid #fff;
	justify-content: space-between;
	width: 100%;
	background: #f3f4f6;
	margin-bottom: 8px;
`;

export const OrderPageInfomationTimeWrapV2 = styled(OrderPageInfomationTimeWrap)`
    flex-direction: column;

`;

export const OrderPageInfomationBottom = styled.div`
	// display: flex;
	padding-top: 12px;
	border-top: 1px solid #E5E7EB;
	width: 100%;
font-size: 14px;
`;

export const OrderPageInfomationBottomSpanRed = styled.span`
	color:red;

`;
export const OrderPageInfomationBottomSpan = styled.span`
	font-weight: bold;

`;


export const OrderPageInfomationTimeLine = styled.div`
	display: flex;
	padding: 4px 0 12px 0;
	width: 100%;
font-size: 14px;
`;

export const OrderPageInfomationTime = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	width: calc(50% - 8px);
`;

export const OrderPageInfomationTimeFlex = styled.div`
display: flex;
    justify-content: space-between;
`;
export const OrderPageInfomationTimeTitle = styled.div`
	color: #111827;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
	margin-bottom: 8px;
`;

export const OrderPageInfomationTimeInputDate = styled.input`
	display: flex;
	height: 44px;
	padding: 8px 12px;
	justify-content: space-between;
	align-items: center;
	border-radius: 8px;
	border: 1px solid #d1d5db;
	background: #fff;
	width: 100%;
	margin-bottom: 8px;
	font-family: inherit;
	type: date;
	background-image: url("./static/img/calendar.png");
	background-repeat: no-repeat;
	background-position: right center;
	background-size: 20px 20px;
	@supports (-webkit-overflow-scrolling: touch) {
		& {
			font-size: 16px;
		}
	}
`;
export const OrderPageInfomationTimeInputTime = styled(OrderPageInfomationTimeInputDate)`
	display: flex;
	height: 44px;
	padding: 8px 12px;
	justify-content: space-between;
	align-items: center;
	border-radius: 8px;
	border: 1px solid #d1d5db;
	background: #fff;
`;

export const OrderPageInfomationQuantityWrap = styled.div`
	border-radius: 8px;
	background: #f3f4f6;
	display: flex;
	padding: 12px 16px;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	margin-bottom: 16px;
`;

export const OrderPageInfomationQuantityTitle = styled.div`
	color: #111827;
	font-size: 14px;
	font-weight: 500;
	line-height: 20px;
`;
export const OrderPageInfomationQuantityTitleInner = styled.div`
	color: #6b7280;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	@media screen and (max-width: 768px) {
		font-size: 12px;
		font-weight: 500;
		line-height: 14px;
	}
`;
export const OrderPageInfomationQuantityLeft = styled.div``;
export const OrderPageInfomationQuantityRight = styled.div`
	display: flex;
`;
export const QuantityButton = styled.div`
	display: flex;
	width: 32px;
	height: 32px;
	padding: 8px 12px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	border-radius: 44px;
	background: #24aae1;
	cursor: pointer;
	color: #fff;
`;
export const QuantityDisplay = styled.div`
	display: flex;
	width: 44px;
	height: v32px;
	padding: 8px 12px;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const OrderPageInfomationPriceDetailWrap = styled.div`
	width: 100%;
	padding-bottom: 16px;
	border-bottom: 1px solid #ddd;
`;
export const OrderPageInfomationPriceDetailTitle = styled.div`
	color: #111827;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
`;
export const OrderPageInfomationPriceDetailInner = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	align-self: stretch;
	margin-top: 16px;
	@media screen and (max-width: 768px) {
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		margin-top: 8px;
	}
`;
export const OrderPageInfomationPriceDetailInnerWrap = styled.div`
	display: flex;
	align-items: center;
`;
export const OrderPageInfomationPriceDetailInnerImg = styled.img`
	width: 16px;
	height: 16px;
	margin-left: 4px;
	cursor: pointer;
`;
export const OrderPageInfomationPriceDetailInnerBland = styled.div`
	color: #6b7280;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	margin-top: 4px;
`;
export const OrderPageInfomationPriceDetailInnerBlandv2 = styled.div`
	color: #6b7280;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	margin-top: 4px;
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const OrderPageInfomationPriceDetailInnerBlandv2Mobile = styled.div`
	display: none;
	@media screen and (max-width: 768px) {
		display: flex;
		color: #6b7280;
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		margin-left: 8px;
	}
`;

export const OrderPageInfomationPriceDetailTotal = styled.div`
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	padding-top: 16px;
`;
export const OrderPageInfomationPriceDetailTotalLeft = styled.div`
	color: #111827;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
`;
export const OrderPageInfomationPriceDetailTotalRight = styled.div`
	color: #035d9d;
	font-size: 16px;
	font-weight: 600;
	line-height: 20px;
`;

export const PartnerInnerTopNameImg = styled.img`
	width: 28px;
	height: 28px;
	margin-right: 12px;
`;

export const PartnerInnerTopNameOrder = styled.div`
	font-size: 24px;
	font-style: normal;
	font-weight: 600;
	line-height: 28px;
	display: flex;
	align-items: center;
	@media screen and (max-width: 768px) {
		font-size: 16px;
		font-weight: 600;
		line-height: 24px;
	}
`;
export const PartnerInnerOrderPageInfomation = styled.div`
	display: flex;
	// align-items: center;
	padding-bottom: 12px;
	align-items: flex-start;

`;
export const OrderPageCheckoutLeft = styled.div`
	@media screen and (max-width: 768px) {
		width: 100%;
		padding: 0 16px;
	}
`;
export const OrderPageCheckoutRight = styled.div``;
export const OrderpageInfomationRight = styled.div`
	margin-bottom: 20px;
`;
export const OrderpageInfomationRightTitle = styled.div`
	display: flex;
	mảgin-bottom: 4px;
`;
export const OrderpageInfomationRightTitleIcon = styled.img`
	height: 20px;
	width: 20px;
	margin-right: 6px;
`;
export const OrderpageInfomationRightTitleName = styled.div`
	color: #111827;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
`;
export const OrderpageInfomationRightInfo = styled.div`
	color: #111827;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	margin-left: 26px;
`;

export const OrderPageInfomationCheckoutDetailWrap = styled.div`
	width: 100%;
	padding-bottom: 20px;
	padding-top: 20px;
	border-bottom: 1px solid #ddd;
	border-top: 1px solid #ddd;
`;

export const OrderStatusIntroInner = styled.div`
    width: 1200px;
    position: relative;
    margin:auto;
    padding:80px 0;
    max-width: 1440px;
    display: flex;
    font-size:16px;
    justify-content: space-between;
    @media screen and (max-width: 768px) {
		margin: 0;
    width: 100%;
    padding: 16px;
    height: calc(100vh - 92px);
	    align-items: center;
   
}
	}
`;

export const OrderSuccessWrap = styled.div`
	display: flex;
	width: 100%;
`;
export const OrderSuccessLeft = styled.div`
	width: calc(100% - 590px);
	margin-right: 100px;
	@media screen and (max-width: 768px) {
		width: 100%;
		margin-right: 0px;
		display: flex;
		flex-direction: column;
		align-items: center;
	}
`;
export const OrderSuccessRight = styled.div`
	@media screen and (max-width: 768px) {
		display: none;
	}
`;
export const OrderSuccessLeftImg = styled.img`
	height: 96px;
	margin-bottom: 12px;
`;
export const OrderSuccessTitle = styled.div`
	color: #111827;
	font-size: 24px;
	font-weight: 600;
	line-height: 28px;

	margin-bottom: 12px;
`;
export const OrderSuccessContent = styled.div`
	color: #111827;
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	margin-bottom: 24px;
	@media screen and (max-width: 768px) {
		text-align: center;
	}
`;
export const OrderSuccessButtonWrap = styled.div`
	display: flex;
	@media screen and (max-width: 768px) {
		position: absolute;
		bottom: 24px;
		left: 50%;
		transform: translateX(-50%);
		width: 100%;
	}
`;
export const OrderSuccessButtonBackHome = styled(Link)`
	display: flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	background: #035d9d;
	color: #fff;
	margin-right: 12px;
	text-decoration: none;
	@media screen and (max-width: 768px) {
		width: 100%;
		margin-right: 12px;
		margin-left: 12px;
	}
`;
export const OrderSuccessButtonBackHomev2 = styled(OrderSuccessButtonBackHome) <{ user: User | null | undefined }>`
	@media screen and (max-width: 768px) {
		width: ${({ user }) => (user ? "calc(50% - 18px)" : "100%")};
	}
`;
export const OrderSuccessButtonDetail = styled(Link)`
	display: flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	border: 1px solid #e5e7eb;
	background: #fff;
	text-decoration: none;
	color: black;
	@media screen and (max-width: 768px) {
		width: calc(50% - 18px);
		margin-right: 12px;
	}
`;
export const PaymentSuccessInnerWrap = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
`;
export const PaymentSuccessInnerImg = styled.img`
	width: 116px;
	height: 136px;
	margin-bottom: 24px;
`;
export const PaymentSuccessInnerTitle = styled.div`
	color: #111827;
	text-align: center;
	font-size: 24px;
	font-weight: 600;
	line-height: 28px;
	margin-bottom: 7px;
	@media screen and (max-width: 768px) {
		font-size: 20px;
		font-weight: 600;
		line-height: 28px;
	}
`;
export const PaymentSuccessInnerContent = styled.div`
	color: #111827;
	text-align: center;
	font-size: 16px;
	font-weight: 400;
	line-height: 24px;
	margin-bottom: 24px;
	@media screen and (max-width: 768px) {
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
	}
`;
export const PaymentSuccessInnerButton = styled.div`
	display: flex;
	padding: 12px 16px;
	justify-content: center;
	align-items: center;
	border-radius: 8px;
	background: #035d9d;
	color: #fff;
	width: 100%;
`;
export const TooltipContent = styled.ul`
	padding: 16px 28px;
	// list-style-type: none;
	// margin: -4px -8px;

	li {
		// padding: 4px 0;
	}
	// background-color: #111827;
	font-size: 14px;
	line-height: 20px;
	border-radius: 8px;
`;

export const TooltipContentWrap = styled(Tooltip)`
	// background-color: #111827;
`;

export const ImgStripePayment = styled.img`
	height: 46px;
	@media screen and (max-width: 768px) {
		height: 36px;
	}
`;
export const ImgStripePaymentWrap = styled(OrderPageCheckoutPay)`
margin-top:8px;
margin-bottom:8px;
	height: 60px;
	@media screen and (max-width: 768px) {
		height: 50px;
	}
`;

export const PaymentCreditCardWrap = styled.div`
	margin-right: 1px;

  

	@media screen and (max-width: 768px) {

	}
`;

export const PaymentCreditTop = styled.div`
	height: 9px;

  

	@media screen and (max-width: 768px) {

	}
`;

export const PaymentCreditPaypal = styled.div`
margin-top:8px;
margin-bottom:8px;
	@media screen and (max-width: 768px) {

	}
`;

export const GooglePayButton = styled.button`
	width: 100%;
	height: 40px;
	background-color: #000;
	color: #fff;
	border: none;
	border-radius: 4px;
	cursor: pointer;
	font-size: 16px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	transition: background-color 0.2s ease;

	&:hover {
		background-color: #333;
	}

	&:disabled {
		background-color: #ccc;
		cursor: not-allowed;
	}

	@media screen and (max-width: 768px) {
		height: 36px;
		font-size: 14px;
	}
`;

export const GooglePayIcon = styled.svg`
	width: 20px;
	height: 20px;
`;

export const PaymentStripPaydWrap = styled.div`
	border-radius: 4px;
	border: 1px solid #000;
`;
